/* Fiche produit : carrousel mobile + barre de progression, galerie plein écran, clip YouTube au clic, barre d'achat mobile */
(function () {
  'use strict';
  function init() {
    const g = document.querySelector('.pp-galerie');
    if (g && !g.dataset.pret) {
      g.dataset.pret = '1';
      const barre = document.querySelector('#pp-points i'), figs = g.querySelectorAll('figure'), n = figs.length;
      if (barre && n) {
        barre.style.transform = 'scaleX(' + (1 / n) + ')';
        g.addEventListener('scroll', function () { const max = g.scrollWidth - g.clientWidth, p = max > 0 ? g.scrollLeft / max : 0; barre.style.transform = 'scaleX(' + ((1 + p * (n - 1)) / n) + ')'; }, { passive: true });
      }
      // galerie plein écran
      const imgs = Array.prototype.slice.call(g.querySelectorAll('figure:not(.pp-montage) img')), boite = document.getElementById('pp-boite');
      if (boite && imgs.length) {
        const im = document.getElementById('pp-boite-img'), compte = document.getElementById('pp-boite-compte');
        let k = 0, x0 = null;
        const voir = function (i) { k = (i + imgs.length) % imgs.length; im.src = imgs[k].currentSrc || imgs[k].src; im.alt = imgs[k].alt; compte.textContent = (k + 1) + ' / ' + imgs.length; };
        imgs.forEach(function (f, i) { f.parentNode.addEventListener('click', function (e) { if (e.target.closest('a')) return; voir(i); document.documentElement.classList.add('verrou'); boite.showModal(); }); });
        boite.querySelector('.prec').addEventListener('click', function () { voir(k - 1); });
        boite.querySelector('.suiv').addEventListener('click', function () { voir(k + 1); });
        boite.querySelector('.pp-boite-fermer').addEventListener('click', function () { boite.close(); });
        boite.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') voir(k - 1); if (e.key === 'ArrowRight') voir(k + 1); });
        boite.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        boite.addEventListener('touchend', function (e) { if (x0 === null) return; const d = e.changedTouches[0].clientX - x0; if (Math.abs(d) > 40) voir(k + (d < 0 ? 1 : -1)); x0 = null; });
      }
    }
    // clip YouTube chargé seulement au clic
    document.querySelectorAll('.pp-video[data-youtube]').forEach(function (b) {
      if (b.dataset.pret) return; b.dataset.pret = '1';
      b.addEventListener('click', function () {
        b.insertAdjacentHTML('beforeend', '<iframe src="https://www.youtube-nocookie.com/embed/' + b.dataset.youtube + '?autoplay=1&rel=0" title="' + (b.getAttribute('aria-label') || (((window.ama && window.ama.t) || {}).clip || '')) + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>');
      }, { once: true });
    });
    // barre d'achat mobile : apparaît quand le bouton principal sort de l'écran
    const btn = document.getElementById('pp-ajout'), barre = document.getElementById('pp-barre');
    if (btn && barre && !barre.dataset.pret) {
      barre.dataset.pret = '1';
      new IntersectionObserver(function (es) { const vis = es[0].isIntersecting || es[0].boundingClientRect.top > 0; barre.classList.toggle('on', !vis); barre.setAttribute('aria-hidden', String(vis)); }).observe(btn);
    }
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
